
import React, { useState } from 'react';
import KMLGenerator from './KMLGenerator';
import KMLViewer from './KMLViewer';

const EmbeddedKMLGenerator = () => {
  const [mode, setMode] = useState<'generator' | 'viewer'>('generator');

  return (
    <div className="min-h-screen bg-gray-50 py-4 px-4">
      <div className="container mx-auto">
        {mode === 'generator' ? (
          <KMLGenerator 
            mode={mode} 
            onModeChange={setMode} 
            showModeToggle={true}
            isEmbedded={true}
          />
        ) : (
          <KMLViewer 
            mode={mode} 
            onModeChange={setMode} 
            showModeToggle={true} 
          />
        )}
      </div>
    </div>
  );
};

export default EmbeddedKMLGenerator;
